import React from 'react';
import { COLORS } from '../../../game/data/colors';
import { SIDEBAR_WIDTH } from '../../Map/WorldMap';
import { DATA } from '../../../game/data';
import { AirplaneSidebar } from './AirplaneSidebar/AirplaneSidebar';
import { AirportSidebar } from './AirportSidebar/AirportSidebar';
import { LoungeSidebar } from './LoungeSidebar/LoungeSidebar';
import { ManagerSidebar } from './ManagerSidebar/ManagerSidebar';
import { observer } from 'mobx-react-lite';
import { SidebarTab } from '../Reusable/SidebarTab';
import { IMAGES } from '../../../game/data/images';
import { ToggleButton } from '../Reusable/ToggleButton';

interface Props {}

export const Sidebar: React.FC<Props> = observer(({}) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        backgroundColor: COLORS.zinc_800,
        display: 'flex',
        flexDirection: 'column',
        width: SIDEBAR_WIDTH,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ display: 'flex', paddingBottom: 0, backgroundColor: COLORS.zinc_900, marginBottom: 4 }}>
        <SidebarTab $active={DATA.sidebarSection === 'airplanes'} onClick={() => DATA.setOpenSidebar('airplanes')}>
          <img src={IMAGES.airplane} />
          AIRPLANES
        </SidebarTab>
        <SidebarTab $active={DATA.sidebarSection === 'airports'} onClick={() => DATA.setOpenSidebar('airports')}>
          <img src={IMAGES.airport} />
          AIRPORTS
        </SidebarTab>
        <SidebarTab $active={DATA.sidebarSection === 'managers'} onClick={() => DATA.setOpenSidebar('managers')}>
          <img src={IMAGES.manager} />
          MANAGERS
        </SidebarTab>
        <SidebarTab $active={DATA.sidebarSection === 'lounges'} onClick={() => DATA.setOpenSidebar('lounges')}>
          <img src={IMAGES.lounge} />
          LOUNGES
        </SidebarTab>
      </div>
      <div
        style={{
          marginRight: 4,
          paddingLeft: 16,
          paddingRight: 12,
          paddingTop: 4, // for the yellow outline in aiport
          overflowY: 'auto',
          flex: 1,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
          <ToggleButton onClick={() => DATA.setBuyMode('buy-1')} $active={DATA.buyMode === 'buy-1'}>
            Buy 1
          </ToggleButton>
          <ToggleButton onClick={() => DATA.setBuyMode('buy-max')} $active={DATA.buyMode === 'buy-max'}>
            Buy max
          </ToggleButton>
        </div>
        {DATA.sidebarSection === 'airplanes' && <AirplaneSidebar />}
        {DATA.sidebarSection === 'airports' && <AirportSidebar />}
        {DATA.sidebarSection === 'managers' && <ManagerSidebar />}
        {DATA.sidebarSection === 'lounges' && <LoungeSidebar />}
      </div>
    </div>
  );
});
